const localEnvs = ['localhost', 'ngrok.io']
const devEnvs = [
	...localEnvs,
	'netlify.app',
	'dev2.emma-live.com',
	'99.emma-live.com',
	'staging.uk.emma-live.com',
	'99.widget.elnk.co',
]

const HOST = window.location.origin

const VITE_NODE_ENV = import.meta.env.VITE_NODE_ENV
const envCheckerCb = (x) => HOST.trim().toLocaleLowerCase().includes(x.trim().toLocaleLowerCase())
export const isLocalEnv = localEnvs.some(envCheckerCb)
export const isDevEnv = devEnvs.some(envCheckerCb) || VITE_NODE_ENV === 'development'

const ENV_API_BASE_URL = import.meta.env.VITE_API_BASE_URL
const API_EMBED_BASE_URL = 'https://widget.elnk.co'
const apiBaseUrl = ENV_API_BASE_URL || HOST
export const baseUrl = apiBaseUrl

const apiVersion = 'v1'
const getPrefix = () => `${apiBaseUrl}/api/${apiVersion}`
const getEmbedPrefix = () => `${API_EMBED_BASE_URL}/api/v1`

const _checkout_pay_ = `/checkout/pay/`

export default {
	terminology: `${getPrefix()}/terminology`,
	settings: `${getPrefix()}/app/settings`,
	status: `${getPrefix()}/app/status`,
	login_requirements: `${getPrefix()}/users/login-requirements`,
	login: `${getPrefix()}/users/login`,
	register: `${getPrefix()}/users/register`,
	otp: `${getPrefix()}/users/otp`,
	otp_resend: `${getPrefix()}/users/otp/resend`,
	forgot_password: `${getPrefix()}/users/forgot-password`,
	reset_password: `${getPrefix()}/users/reset-password`,
	resend_pin: `${getPrefix()}/users/resend-pin`,
	logout: `${getPrefix()}/users/logout`,
	user_profile: `${getPrefix()}/users/profile`,
	fa_icons: `${getPrefix()}/fontawesome-icon-list`,
	genericPage: (routeKey) => `${getPrefix()}/pages/${routeKey}`,
	withSuffix: (suffix) => `${getPrefix()}${suffix}`,
	getAdmin: (suffix) => `${getPrefix()}/admin${suffix}`,
	checkout: {
		pay: {
			stripe: `${getPrefix()}${_checkout_pay_}stripe`,
			directDebit: `${getPrefix()}${_checkout_pay_}direct-debit`,
			offline: `${getPrefix()}${_checkout_pay_}offline`,
		},
		confirm: {
			stripe: `${getPrefix()}${_checkout_pay_}stripe/confirm`,
			directDebit: `${getPrefix()}${_checkout_pay_}direct-debit/confirm`,
		},
	},
	validate_embed_token: `${getEmbedPrefix()}/validate`,
}
